import { NgModule } from '@angular/core';
import { TrustedIframeSrcDirective } from './trusted-iframe-src.directive';

// A directive can only be declared by one NgModule, and this one is needed by
// both HomeModule (the video testimonials block) and MediaBlogModule (the
// Videos tab). Wrapping it in its own module is the way both get it -- the
// same shape as HomeOemPartsModule and RevampPartsBannerModule.
@NgModule({
  declarations: [TrustedIframeSrcDirective],
  exports: [TrustedIframeSrcDirective],
})
export class TrustedIframeSrcModule { }
